import { createTheme, MantineProvider } from "@mantine/core"

import App from "./App"

const theme = createTheme({
  defaultRadius: "md",
  primaryColor: "blue",
  autoContrast: true,
  luminanceThreshold: 0.4,
  primaryShade: {
    light: 5,
    dark: 6
  }
})

export function Root(): React.ReactElement {
  return (
    <MantineProvider theme={theme} defaultColorScheme={"auto"}>
      <App />
    </MantineProvider>
  )
}
